import React from 'react';
// import SarasDnDList from '../../../../library/hooks/bdnd/SarasDnDList';
import SarasDnDList from '../../../../library/hooks/dndkit/SarasDnDList';
import VoucherDetailRow from './VoucherDetailRow'

const VoucherDetailRowDNDList = (props) => {
    const { formObject, viewData, rowKeys, sarasDnDManager } = props;

    const renderVoucherRows = (rowId, index) => {
        let row = viewData[rowId];

        return (
            <li key={rowId} rowKey={rowId} style={{listStyle: 'none'}}>
                <VoucherDetailRow formObject={formObject} index={index} rowKey={rowId} 
                    viewData={row}
                    groupKey={1} isSortMode={sarasDnDManager.isSortMode()}
                />
            </li>
        )
    }

    return (
        <SarasDnDList groupKey={1} sarasDnDManager={sarasDnDManager} >
            {
                rowKeys && rowKeys.map((rowId, index) => (
                    renderVoucherRows(rowId, index)
                ))
            }
        </SarasDnDList>
    )
}

export default VoucherDetailRowDNDList
